
import {
  defineComponent, PropType, Ref, ref, computed,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Calendar from 'primevue/calendar';
import { FieldConfig, ParserFieldObject, Property } from '@/types';
import ToggleDisplaySettings from '@/components/template-builder/fields/partials/ToggleDisplaySettings.vue';

export default defineComponent({
  name: 'DatetimePicker',

  components: {
    ToggleDisplaySettings,
    Calendar,
  },

  props: {
    configs: {
      type: Object as PropType<FieldConfig>,
      required: true,
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true,
    },

    elementPartType: {
      type: String,
      required: false,
      default: '',
    },
  },

  emits: ['on-change-properties'],

  setup(props, context) {
    const { t } = useI18n();
    const configs = ref(props.configs);
    const displayProperties = ref(!(!Object.prototype.hasOwnProperty.call(configs.value, 'displayToggle') || configs.value.displayToggle === true));
    const property: Ref<Property> = ref(props.parserValues.properties && props.parserValues.properties[0]);

    // Parse initial date from ISO string
    const parseDate = (value: string): Date => {
      if (!value) {
        // Default: 7 days from now
        return new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
      }
      const date = new Date(value);
      return isNaN(date.getTime()) ? new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) : date;
    };

    const selectedDate = ref<Date>(parseDate(property.value?.value ?? props.configs.options?.defaultValue));

    // Minimum date is now
    const minDate = computed(() => new Date());

    const handleDateChange = (value: Date) => {
      if (!value) return;

      selectedDate.value = value;
      const isoString = value.toISOString();

      if (property.value) {
        property.value.value = isoString;
        context.emit('on-change-properties', {
          selector: props.parserValues.selector,
          properties: [property.value],
        });
      }
    };

    return {
      t,
      configs,
      displayProperties,
      selectedDate,
      minDate,
      handleDateChange,
    };
  },
});
